import { useMutation, useQuery } from 'react-query';
import { PecaAiAggregationListRequest } from './pecaAi.types';
import pecaAiServices from './pecaAi.services';
import notificationError from '@/utils/functions/notificationError';

const PECAAI_BRAND_LIST = 'pecaAi/brand/list';
const PECAAI_GROUP_LIST = 'pecaAi/group/list';
const PECAAI_BUYER = 'pecaAi/buyer';

export function usePecaAiBrandList(params: PecaAiAggregationListRequest) {
  return useQuery(
    [PECAAI_BRAND_LIST, { ...params }],
    () => pecaAiServices.brandList(params),
    {
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function usePecaAiGroupList(params: PecaAiAggregationListRequest) {
  return useQuery(
    [PECAAI_GROUP_LIST, { ...params }],
    () => pecaAiServices.groupList(params),
    {
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function usePecaAiSearchProduct() {
  return useMutation(pecaAiServices.searchProduct, {
    onError(err) {
      notificationError(err);
    },
  });
}

export function usePecaAiHasBuyer(cnpj?: string, enabled = true) {
  return useQuery({
    queryKey: [PECAAI_BUYER, cnpj],
    queryFn: () => pecaAiServices.hasBuyer(cnpj as string),
    enabled: !!cnpj && enabled,
  });
}
